import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet-async';

import { processTypes } from '@domain/constants'
import { useSubdomain } from '@domain/hooks';
import { RootState } from '@domain/root-reducer';

interface Props {
    faviconCustom?: string
}

const HtmlHead: FC<Props> = ({ faviconCustom }) => {

    const branding = useSelector((state: RootState) => state.branding)
    const subdomain = useSubdomain();

    if (subdomain === null) {
        return (
            <Helmet />
        )
    }

    const chooseTitle = () => {
        if (!!branding && branding.objectType === processTypes.Schadegarant) {
            return { title: 'eXperience', favicon: '/favicon_sg.ico' }
        }
        else {
            return { title: '', favicon: '/favicon.ico' }
        }
    }

    return (
        <Helmet>
            <title>{chooseTitle().title}</title>
            <link rel="shortcut icon" href={faviconCustom ? 'data:image/x-icon;base64,' + faviconCustom : chooseTitle().favicon} />
        </Helmet>
    );
};


export default HtmlHead;
